import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Trends',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: {
                    '++': [
                      {
                        '@$': 'financialVolume',
                      },
                      ' Performance',
                    ],
                  },
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: {
                            '@$': 'financialVolume',
                          },
                          points: {
                            '@': 'barchartPoints',
                          },
                        },
                      },
                    ],
                  },
                },
              },
            ],
          },
          type: 'bar',
        },
      },
      overflowActions: {
        '[]': [
          {
            '{}': {
              icon: 'atn-icon atn-link',
              action: {
                '{}': {
                  payload: {
                    '{}': {
                      goto: {
                        '{}': {
                          variables: {
                            '{}': {},
                          },
                          navigationId: 'trends',
                        },
                      },
                    },
                  },
                  operation: 'ui.navigate',
                },
              },
            },
          },
        ],
      },
    },
  },
  variables: {
    researchType: [],
    financialVolume: 'TDC',
  },
  subqueries: {
    barchartPoints: {
      target: [
        ['2022-01-01', '2022-12-31'],
        ['2023-01-01', '2023-12-31'],
        ['2024-01-01', '2024-12-31'],
      ],
      selection: {
        '{}': {
          x: {
            if: [
              [
                {
                  '=': [
                    {
                      '@$': '$period',
                    },
                    '[2022-01-01,2023-01-01)',
                  ],
                },
                '2022',
              ],
              [
                {
                  '=': [
                    {
                      '@$': '$period',
                    },
                    '[2023-01-01,2024-01-01)',
                  ],
                },
                '2023',
              ],
              [
                {
                  '=': [
                    {
                      '@$': '$period',
                    },
                    '[2024-01-01,2025-01-01)',
                  ],
                },
                '2024',
              ],
            ],
          },
          y: {
            if: [
              [
                {
                  not: {
                    '=': [
                      {
                        '@$': 'piRecordId',
                      },
                      null,
                    ],
                  },
                },
                {
                  '+': {
                    '@': 'piGlExpenses',
                  },
                },
              ],
              [
                {
                  and: [
                    {
                      not: {
                        '=': [
                          {
                            '@$': 'orgRecordId',
                          },
                          null,
                        ],
                      },
                    },
                    {
                      '=': [
                        {
                          '@$': 'orgEntityId',
                        },
                        'ent:!org:!div',
                      ],
                    },
                  ],
                },
                {
                  '+': {
                    '@': 'divGlExpenses',
                  },
                },
              ],
              [
                {
                  and: [
                    {
                      not: {
                        '=': [
                          {
                            '@$': 'orgRecordId',
                          },
                          null,
                        ],
                      },
                    },
                    {
                      '=': [
                        {
                          '@$': 'orgEntityId',
                        },
                        'ent:!org:!dept',
                      ],
                    },
                  ],
                },
                {
                  '+': {
                    '@': 'deptGlExpenses',
                  },
                },
              ],
              {
                '+': {
                  '@': 'projectGlExpenses',
                },
              },
            ],
          },
          piGlExpenses: {
            '@': 'piGlExpenses',
          },
          divGlExpenses: {
            '@': 'divGlExpenses',
          },
          deptGlExpenses: {
            '@': 'deptGlExpenses',
          },
          projectGlExpenses: {
            '@': 'projectGlExpenses',
          },
        },
      },
      subqueries: {
        piGlExpenses: {
          filter: {
            and: [
              {
                '@$': 'piRecordId',
              },
              {
                '=': [
                  {
                    '@$': 'piRecordId',
                  },
                  {
                    '@.': '!id',
                  },
                ],
              },
            ],
          },
          target: 'ent:!personnel:!employee',
          selection: {
            '+': {
              '@': 'projectsExpenses',
            },
          },
          subqueries: {
            projectsExpenses: {
              ref: {
                attr: 'attr:ent#!proj_pis#!entry:!proj',
              },
              using: 'piProjectAssignments',
              filter: {
                and: [
                  {
                    not: {
                      '=': [
                        {
                          '@': 'projectGlExpenseAmounts',
                        },
                        null,
                      ],
                    },
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '@$': 'researchType',
                          },
                          null,
                        ],
                      },
                      {
                        '=': [
                          {
                            '#': {
                              '@$': 'researchType',
                            },
                          },
                          0,
                        ],
                      },
                      {
                        in: [
                          {
                            '@': 'researchType',
                          },
                          {
                            '@$': 'researchType',
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              target: 'ent:!projects:!proj',
              selection: {
                '+': {
                  '->': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        {
                          if: [
                            [
                              {
                                '=': [
                                  {
                                    '@$': 'financialVolume',
                                  },
                                  'MTDC',
                                ],
                              },
                              'mtdcAmount',
                            ],
                            'tdcAmount',
                          ],
                        },
                      ],
                    },
                  ],
                },
              },
              subqueries: {
                researchType: {
                  ref: {
                    attr: 'attr:ent#!projects#!proj:!award',
                  },
                  target: 'ent:!awards:!award',
                  selection: {
                    '@.': '!research_type',
                  },
                },
                projectGlExpenseAmounts: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!proj',
                  },
                  target: 'ent:!gl_exp:!entry',
                  selection: {
                    '{}': {
                      tdcAmount: {
                        if: [
                          [
                            {
                              '!=': [
                                {
                                  '@.': [
                                    '!acct',
                                    {
                                      ref: {
                                        entity: '!acct',
                                      },
                                    },
                                  ],
                                },
                                '?7631013',
                              ],
                            },
                            {
                              '@.': '!amount',
                            },
                          ],
                          0,
                        ],
                      },
                      mtdcAmount: {
                        if: [
                          [
                            {
                              '@': 'isInMtdc',
                            },
                            {
                              '@.': '!amount',
                            },
                          ],
                          0,
                        ],
                      },
                    },
                  },
                  subqueries: {
                    isInMtdc: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!acct',
                      },
                      target: 'ent:!gl_accts:!acct',
                      selection: {
                        '@.': '!is_in_mtdc',
                      },
                    },
                  },
                },
              },
            },
            piProjectAssignments: {
              ref: {
                attr: 'attr:ent#!proj_pis#!entry:!pi',
              },
              target: 'ent:!proj_pis:!entry',
            },
          },
        },
        divGlExpenses: {
          filter: {
            and: [
              {
                '@$': 'orgRecordId',
              },
              {
                '@$': 'orgEntityId',
              },
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  {
                    '@.': '!id',
                  },
                ],
              },
              {
                '=': [
                  {
                    '@$': 'orgEntityId',
                  },
                  'ent:!org:!div',
                ],
              },
            ],
          },
          target: 'ent:!org:!div',
          selection: {
            '+': {
              '@': 'projectsExpenses',
            },
          },
          subqueries: {
            projectsExpenses: {
              ref: {
                attr: 'attr:ent#!projects#!proj:!org',
                inherit: '-',
              },
              filter: {
                and: [
                  {
                    not: {
                      '=': [
                        {
                          '@': 'projectGlExpenseAmounts',
                        },
                        null,
                      ],
                    },
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '@$': 'researchType',
                          },
                          null,
                        ],
                      },
                      {
                        '=': [
                          {
                            '#': {
                              '@$': 'researchType',
                            },
                          },
                          0,
                        ],
                      },
                      {
                        in: [
                          {
                            '@': 'researchType',
                          },
                          {
                            '@$': 'researchType',
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              target: 'ent:!projects:!proj',
              selection: {
                '+': {
                  '->': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        {
                          if: [
                            [
                              {
                                '=': [
                                  {
                                    '@$': 'financialVolume',
                                  },
                                  'MTDC',
                                ],
                              },
                              'mtdcAmount',
                            ],
                            'tdcAmount',
                          ],
                        },
                      ],
                    },
                  ],
                },
              },
              subqueries: {
                researchType: {
                  ref: {
                    attr: 'attr:ent#!projects#!proj:!award',
                  },
                  target: 'ent:!awards:!award',
                  selection: {
                    '@.': '!research_type',
                  },
                },
                projectGlExpenseAmounts: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!proj',
                  },
                  target: 'ent:!gl_exp:!entry',
                  selection: {
                    '{}': {
                      tdcAmount: {
                        if: [
                          [
                            {
                              '!=': [
                                {
                                  '@.': [
                                    '!acct',
                                    {
                                      ref: {
                                        entity: '!acct',
                                      },
                                    },
                                  ],
                                },
                                '?7631013',
                              ],
                            },
                            {
                              '@.': '!amount',
                            },
                          ],
                          0,
                        ],
                      },
                      mtdcAmount: {
                        if: [
                          [
                            {
                              '@': 'isInMtdc',
                            },
                            {
                              '@.': '!amount',
                            },
                          ],
                          0,
                        ],
                      },
                    },
                  },
                  subqueries: {
                    isInMtdc: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!acct',
                      },
                      target: 'ent:!gl_accts:!acct',
                      selection: {
                        '@.': '!is_in_mtdc',
                      },
                    },
                  },
                },
              },
            },
          },
        },
        deptGlExpenses: {
          filter: {
            and: [
              {
                '@$': 'orgRecordId',
              },
              {
                '@$': 'orgEntityId',
              },
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  {
                    '@.': '!id',
                  },
                ],
              },
              {
                '=': [
                  {
                    '@$': 'orgEntityId',
                  },
                  'ent:!org:!dept',
                ],
              },
            ],
          },
          target: 'ent:!org:!dept',
          selection: {
            '+': {
              '@': 'projectsExpenses',
            },
          },
          subqueries: {
            projectsExpenses: {
              ref: {
                attr: 'attr:ent#!projects#!proj:!org',
              },
              filter: {
                and: [
                  {
                    not: {
                      '=': [
                        {
                          '@': 'projectGlExpenseAmounts',
                        },
                        null,
                      ],
                    },
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '@$': 'researchType',
                          },
                          null,
                        ],
                      },
                      {
                        '=': [
                          {
                            '#': {
                              '@$': 'researchType',
                            },
                          },
                          0,
                        ],
                      },
                      {
                        in: [
                          {
                            '@': 'researchType',
                          },
                          {
                            '@$': 'researchType',
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              target: 'ent:!projects:!proj',
              selection: {
                '+': {
                  '->': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        {
                          if: [
                            [
                              {
                                '=': [
                                  {
                                    '@$': 'financialVolume',
                                  },
                                  'MTDC',
                                ],
                              },
                              'mtdcAmount',
                            ],
                            'tdcAmount',
                          ],
                        },
                      ],
                    },
                  ],
                },
              },
              subqueries: {
                researchType: {
                  ref: {
                    attr: 'attr:ent#!projects#!proj:!award',
                  },
                  target: 'ent:!awards:!award',
                  selection: {
                    '@.': '!research_type',
                  },
                },
                projectGlExpenseAmounts: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!proj',
                  },
                  target: 'ent:!gl_exp:!entry',
                  selection: {
                    '{}': {
                      tdcAmount: {
                        if: [
                          [
                            {
                              '!=': [
                                {
                                  '@.': [
                                    '!acct',
                                    {
                                      ref: {
                                        entity: '!acct',
                                      },
                                    },
                                  ],
                                },
                                '?7631013',
                              ],
                            },
                            {
                              '@.': '!amount',
                            },
                          ],
                          0,
                        ],
                      },
                      mtdcAmount: {
                        if: [
                          [
                            {
                              '@': 'isInMtdc',
                            },
                            {
                              '@.': '!amount',
                            },
                          ],
                          0,
                        ],
                      },
                    },
                  },
                  subqueries: {
                    isInMtdc: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!acct',
                      },
                      target: 'ent:!gl_accts:!acct',
                      selection: {
                        '@.': '!is_in_mtdc',
                      },
                    },
                  },
                },
              },
            },
          },
        },
        projectGlExpenses: {
          filter: {
            and: [
              {
                '=': [
                  {
                    '@$': 'piRecordId',
                  },
                  null,
                ],
              },
              {
                or: [
                  {
                    '=': [
                      {
                        '@$': 'orgRecordId',
                      },
                      null,
                    ],
                  },
                  {
                    '=': [
                      {
                        '@$': 'orgEntityId',
                      },
                      null,
                    ],
                  },
                ],
              },
              {
                or: [
                  {
                    '=': [
                      {
                        '@$': 'researchType',
                      },
                      null,
                    ],
                  },
                  {
                    '=': [
                      {
                        '#': {
                          '@$': 'researchType',
                        },
                      },
                      0,
                    ],
                  },
                  {
                    in: [
                      {
                        '@': 'researchType',
                      },
                      {
                        '@$': 'researchType',
                      },
                    ],
                  },
                ],
              },
            ],
          },
          target: 'ent:!projects:!proj',
          selection: {
            '+': {
              '->': [
                {
                  '@': 'glExpenses',
                },
                {
                  '@>': [
                    {
                      '@$': '$value',
                    },
                    {
                      if: [
                        [
                          {
                            '=': [
                              {
                                '@$': 'financialVolume',
                              },
                              'MTDC',
                            ],
                          },
                          'mtdcAmount',
                        ],
                        'tdcAmount',
                      ],
                    },
                  ],
                },
              ],
            },
          },
          subqueries: {
            glExpenses: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!gl_exp:!entry',
              selection: {
                '{}': {
                  tdcAmount: {
                    if: [
                      [
                        {
                          '!=': [
                            {
                              '@.': [
                                '!acct',
                                {
                                  ref: {
                                    entity: '!acct',
                                  },
                                },
                              ],
                            },
                            '?7631013',
                          ],
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                  mtdcAmount: {
                    if: [
                      [
                        {
                          '@': 'isInMtdc',
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                isInMtdc: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!acct',
                  },
                  target: 'ent:!gl_accts:!acct',
                  selection: {
                    '@.': '!is_in_mtdc',
                  },
                },
              },
            },
            researchType: {
              ref: {
                attr: 'attr:ent#!projects#!proj:!award',
              },
              target: 'ent:!awards:!award',
              selection: {
                '@.': '!research_type',
              },
            },
          },
        },
      },
    },
  },
}
